import { Box, Paper, Skeleton, Stack } from '@mui/material';

const VoiceCardLoader = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 2,
        border: '1px solid #dbd4d4ff',
        px: 2,
        py: 2,
        mt: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2
      }}
    >
      {/* Left side: Name + Verified + Description */}
      <Box flex={1}>
        <Box display='flex' flexDirection='row' alignItems='center' gap={1}>
          <Skeleton variant='text' width={80} height={24} />
          <Skeleton variant='circular' width={18} height={18} />
        </Box>
        <Skeleton variant='text' width={160} height={20} sx={{ mt: 1 }} />
      </Box>

      {/* Right side: Play + Edit */}
      <Stack direction='row' spacing={1} alignItems='center'>
        <Skeleton variant='circular' width={36} height={36} />
        <Skeleton variant='rectangular' width={60} height={32} sx={{ borderRadius: '999px' }} />
      </Stack>
    </Paper>
  );
};

export default VoiceCardLoader;
